export default __webpack_public_path__ + "static/media/bg3.1f31d443.svg";